import { postRequest } from '@/core';
import { trips } from '@/requests';

export default async function(id) {
	let url = trips.openTmsR10Path(id);
	let response = await postRequest(url);
	return response;
}